import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import RateLimitModal from '../../components/RateLimitModal';
import api from '../../services/api';
import './UtilityPage.css';

const JsonFormatter = () => {
  const { isAuthenticated } = useAuth();
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitError, setRateLimitError] = useState(null);

  const handleFormat = async () => {
    if (!input.trim()) {
      setError('Please enter JSON to format');
      return;
    }

    try {
      setError('');
      const response = await api.post('/api/utilities/json/format', { json: input });
      setOutput(response.data.formatted);
    } catch (err) {
      if (err.response?.status === 429) {
        // Rate limit exceeded
        const errorData = err.response.data;
        setRateLimitError({
          message: errorData.message || 'Rate limit exceeded',
          isAuthenticated: errorData.isAuthenticated !== undefined ? errorData.isAuthenticated : isAuthenticated,
          suggestion: errorData.suggestion || '',
          currentLimit: errorData.currentLimit || '',
          loginLimit: errorData.loginLimit || '',
          premiumLimit: errorData.premiumLimit || ''
        });
        setShowRateLimitModal(true);
      } else {
        setError(err.response?.data?.error || 'Failed to format JSON');
        setOutput('');
      }
    }
  };

  return (
    <div className="utility-page">
      <BackButton />
      <div className="utility-container">
        <h1>JSON Formatter</h1>
        <div className="utility-form">
          <div className="input-section">
            <label>Input JSON</label>
            <textarea
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder='{"key": "value"}'
              rows={10}
            />
          </div>
          <button onClick={handleFormat} className="btn-process">Format JSON</button>
          {error && <div className="error-message">{error}</div>}
          {output && (
            <div className="output-section">
              <label>Formatted JSON</label>
              <textarea value={output} readOnly rows={10} />
            </div>
          )}
        </div>
      </div>
      
      {showRateLimitModal && rateLimitError && (
        <RateLimitModal 
          error={rateLimitError}
          onClose={() => {
            setShowRateLimitModal(false);
            setRateLimitError(null);
          }}
        />
      )}
    </div>
  );
};

export default JsonFormatter;

